import React, { useState, useEffect } from 'react';
import { Avatar, Typography, Badge, Divider, Tag, Space, Button } from 'antd';
import { 
  UserOutlined, 
  MedicineBoxOutlined, 
  CheckCircleOutlined,
  ClockCircleOutlined,
  PhoneOutlined,
  MailOutlined
} from '@ant-design/icons';
import './DoctorProfile.css';

const { Title, Text, Paragraph } = Typography;

const DoctorProfile = ({ profile }) => {
    const [status] = useState({
    online: true,
    message: '医生在线'
  });
  const [expertise, setExpertise] = useState([]);

  useEffect(() => {
    // 模拟获取医生状态和专业领域
    setExpertise([
      { name: '口腔正畸', color: 'blue' },
      { name: '正畸培训教育', color: 'orange' },
      { name: '正畸临床支持服务', color: 'purple' }
    ]);
  }, []);

  return (
    <div className="doctor-profile">
      {/* 医生基本信息 */}
      <div className="doctor-header">
        <div className="doctor-avatar-container">
          <Badge 
            status={status === 'online' ? 'success' : 'default'} 
            offset={[-10, 80]}
          >
            <Avatar
              size={100}
              icon={<UserOutlined />}
              src={profile?.avatar}
              className="doctor-avatar"
            />
          </Badge>
        </div>
        
        <div className="doctor-info">
          <Title level={3} className="doctor-name">
            {profile?.name || 'Dr. Duan'}
          </Title>
          <Text className="doctor-title">
            {profile?.title || '口腔正畸医学博士'}
          </Text>
          <Text className="doctor-specialty">
            {profile?.specialty || '口腔正畸专家'}
          </Text>
          <Text className="doctor-experience">
            🏥 {profile?.experience || '丰富的正畸临床与科研经验'}
          </Text>
        </div>
      </div>

      <Divider />

      {/* 在线状态 */}
      <div className="status-section">
        <Space align="center">
          <CheckCircleOutlined 
            style={{ color: status === 'online' ? '#52c41a' : '#d9d9d9' }} 
          />
          <Text strong>
            {status === 'online' ? '在线咨询' : '在线咨询'}
          </Text>
        </Space>
        <Text type="secondary" className="status-text">
          {status === 'online' 
            ? '通常在1分钟内回复' 
            : '通常在1分钟内回复'
          }
        </Text>
      </div>

      <Divider />

      {/* 专业领域 */}
      <div className="expertise-section">
        <Title level={5} className="section-title">
          <MedicineBoxOutlined /> 专业领域
        </Title>
        <div className="expertise-tags">
          {expertise.map((item, index) => (
            <Tag key={index} color={item.color} className="expertise-tag">
              {item.name}
            </Tag>
          ))}
        </div>
      </div>

      <Divider />

      {/* 服务时间 */}
      <div className="schedule-section">
        <Title level={5} className="section-title">
          <ClockCircleOutlined /> 咨询时间
        </Title>
        <div className="schedule-info">
          <Text>专业咨询：24小时在线</Text>
          <br />
          <Text type="secondary">培训课程：根据课程安排</Text>
        </div>
      </div>

      <Divider />

      {/* 所属机构 */}
      <div className="affiliation-section">
        <Title level={5} className="section-title">
          🏢 所属机构
        </Title>
        <div className="affiliation-info">
          <Text>• DSmilife正畸中心</Text>
          <br />
          <Text>• 广州加齐口腔门诊部</Text>
          <br />
          <Text>（DS团队专属教学、临床支持基地）</Text>
        </div>
      </div>

      <Divider />

      {/* 医生格言 */}
      <div className="motto-section">
        <Paragraph italic className="doctor-motto">
          "精准正畸，专业护航；陪伴教育，助力医者成长。"
        </Paragraph>
      </div>

      {/* 联系方式 */}
      <div className="contact-section">
        <Space direction="vertical" size="small" style={{ width: '100%' }}>
          <Button 
            type="primary" 
            icon={<PhoneOutlined />} 
            size="small"
            className="contact-btn"
          >
            预约正畸咨询
          </Button>
          <Button 
            icon={<MailOutlined />} 
            size="small"
            className="contact-btn"
          >
            培训咨询
          </Button>
        </Space>
      </div>
    </div>
  );
};

export default DoctorProfile;
